import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { landslideIspraLegendLevels } from "./LandslideUtils";
import { getGlobalLandslideNowcastCreationTime } from "../../../lib/getRainfallData";

import { legendItemStyle, legendStyle } from "../style";

const LandslideLegend = () => {
  const { t } = useTranslation();
  const [forecastCreationTime, setForecastCreationTime] = useState(null);
  useEffect(() => {
    const fetchCreationTime = async () => {
      try {
        const time = await getGlobalLandslideNowcastCreationTime();

        setForecastCreationTime(time);
      } catch (error) {
        console.error("Error fetching creation time:", error);
      }
    };

    fetchCreationTime();
  }, []);

  return (
    <div style={legendStyle}>
      <div>
        <b>{t("riskAssessment.landslideNowcast")}</b>
      </div>

      <div>
        <span style={legendItemStyle("red")}></span>
        {landslideIspraLegendLevels().high}
      </div>
      <div>
        <span style={legendItemStyle("yellow")}></span>
        {landslideIspraLegendLevels().moderate}
      </div>

      <div>
        {forecastCreationTime && <p>Creation Date: {`${forecastCreationTime.toLocaleDateString("it")}`}</p>}
        {forecastCreationTime && (
          <p>Creation Time: {`${forecastCreationTime.toLocaleTimeString("it")} UTC`}</p>
        )}
      </div>

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © CyStellar, Data from Global Landslide Nowcast from LHASA L4 3-hourly Version 1.1, NASA GSFC,
          Precipitation Processing System, PMM Publisher API: https://pmmpublisher.pps.eosdis.nasa.gov,
          processed by CyStellar
        </span>
      </div>
    </div>
  );
};

export default LandslideLegend;
